/**
 * Created by Ivan on 27/03/2016.
 */


"use strict";
import {AllfinWelcomeWizard} from "../layout/wizard/allfin/AllfinWelcomeWizardComponent";
import {BellmontWelcomeWizard} from "../layout/wizard/bellmont/BellmontWelcomeWizardComponent";
import {FutureAssistWelcomeWizard} from "../layout/wizard/future-assist/FutureAssistWelcomeWizardComponent";
import {GameWelcomeWizardController} from "../layout/wizard/game/GameWelcomeWizardController";
import {IInvestWelcomeWizardController} from "../layout/wizard/iinvest/IInvestWelcomeWizardController";
import {IvWelcomeWizardController} from "../layout/wizard/ivWizard/IvWelcomeWizardController";
import {LiquidityWelcomeWizard} from "../layout/wizard/liquidity/LiquidityWelcomeWizardComponent";
import {FxeWelcomeWizard} from "../layout/wizard/fxe-phillip/FxeWelcomeWizardComponent";
import {OpenMarketsWelcomeWizard} from "../layout/wizard/open-markets/OpenMarketsWelcomeWizardComponent";
import {OpenTraderWelcomeWizard} from "../layout/wizard/open-trader/OpenTraderWelcomeWizardComponent";
import {SuubeeWelcomeWizard} from "../layout/wizard/suubee/SuubeeWelcomeWizardComponent";
import {WaimakWelcomeWizard} from "../layout/wizard/waimak/WaimakWelcomeWizardComponent";
import {Breakpoint} from "../services/breakpoints/Breakpoint";
import {ClientEventType} from "../services/client-events/models/ClientEventType";
import {FeatureNames} from "../types/UserConfig";

{
    var app = angular.module("tf.controllers", [])
                     .controller("SessionErrorCtrl", ["$scope", "$window", function ($scope, $window) {

                         $scope.ok = function () {
                             var source = $window.location.hash.substring(3);
                             var url = "";
                             if (source) {
                                 url += "?source=" + encodeURI(source);
                             }
                             var host = $window.location.host;
                             if (host.indexOf("liquidity") !== -1) {
                                 $window.location.href = "/tradefloor/oauth2/authorization/liquidity" + url;
                             }else if (host.indexOf("tradefloor.com.au") !== -1 || host.indexOf("openmarkets.com.au") !== -1) {
                                 $window.location.href = "/login" + url;
                             }else{
                                $window.location.href = "/#/signin" + url;
                             }
                         }
                     }])

                     .controller("splashCtrl", ["$scope", "$window", function ($scope, $window) {

                         $scope.helpers = [
                             {"name": "tcTV"},
                             {"name": "optionsCourses"},
                             {"name": "strategy"},
                             {"name": "understandOptions"},
                             {"name": "tcTV2"}
                         ];

                     }])

                     .controller("TablePrefCtrl", ["$scope", "gridApi", "uiGridConstants", "$uibModalInstance", function ($scope, gridApi, uiGridConstants, $uibModalInstance) {
                         $scope.gridApi = gridApi;
                         $scope.query = "";

                         $scope.cancel = function () {
                             $uibModalInstance.dismiss()
                         };

                         $scope.hideable = function (value, index) {
                             return value.colDef.enableHiding != false && value.colDef.name !== "treeBaseRowHeaderCol";
                         };

                         $scope.matchesQuery = function (value, index) {
                             if (!$scope.query) {
                                 return true;
                             }


                             if (!value.colDef.term) {
                                 return true;
                             }

                             if (value.colDef.term.description.toLowerCase()
                                      .indexOf($scope.query.toLowerCase()) != -1) {
                                 return true;
                             }

                             return false;
                         };


                         $scope.toggleColumnVisible = function (column) {
                             if (column.visible === undefined || column.visible) {
                                 column.hideColumn();
                             } else {
                                 column.showColumn();
                             }

                             column.grid.queueGridRefresh();
                             column.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                             column.grid.api.core.raise.columnVisibilityChanged(column);

                         };

                         $scope.resetColumns = function (columnFn) {
                             $scope.gridApi.grid.resetColumnSorting();
                             $scope.gridApi.grid.clearAllFilters();

                             $scope.gridApi.grid.options.columnDefs = columnFn();

                             if ($scope.gridApi.grid.options.savePreferencesFn) {
                                 $scope.gridApi.grid.options.savePreferencesFn();
                             }

                         }
                     }])


                     .controller("step1Ctrl", ["$scope", "$uibModal", "userConfig", "$http", "$window", "$timeout", "$filter", "navSvc", "$q", function ($scope, $uibModal, userConfig, $http, $window, $timeout, $filter, navSvc, $q) {
                         var form = $scope.$parent.$parent;
                         var step = form.$parent;
                         var wizard = step.$parent.$parent;

                         $scope.phoneMasks = {
                             mobileMask: "9999 999 999",
                             landlineMask: "(99) 9999 9999",
                             freeCallMask: "9999 999 999"
                         };

                         $scope.selectedPackage = null;
                         $scope.phoneMask = $scope.phoneMasks.landlineMask;

                         $scope.changePhone = function (phoneNumber) {
                             if (phoneNumber === null) {
                                 return;
                             }

                             if (phoneNumber.length >= 2) {
                                 var prefix = phoneNumber.substring(0, 2);
                                 if (prefix == "04") {
                                     $scope.phoneMask = $scope.phoneMasks.mobileMask;
                                 } else if (prefix == "13" || prefix == "18") {
                                     $scope.phoneMask = $scope.phoneMasks.freeCallMask;
                                 } else {
                                     $scope.phoneMask = $scope.phoneMasks.landlineMask;
                                 }
                             } else {
                                 $scope.phoneMask = $scope.phoneMasks.landlineMask;
                             }
                         };

                         $scope.selectPackage = function (packageName) {
                             $scope.selectedPackage = packageName;
                         };

                         $scope.changeCountry = function (country) {
                             wizard.setupData.postcode = null;
                             wizard.setupData.state = null;
                         };

                         $scope.ageGroup = null;

                         $scope.ageGroups = [
                             {key: "U25", value: "< 25"},
                             {key: "O25U35", value: "25 - 34"},
                             {key: "O35U45", value: "35 - 44"},
                             {key: "O45U55", value: "45 - 54"},
                             {key: "O55U65", value: "55 - 64"},
                             {key: "O65", value: "> 64"}
                         ];
                         var ageGroupMap = {};
                         $scope.ageGroups.forEach(function (ageGroup) {
                             ageGroupMap[ageGroup.key] = ageGroup;
                         });

                         $http.get("app/layout/legal/legal.json")
                              .then(function (result) {

                                  function htmlify(value) {
                                      var bold = /“(.*?)”/g;
                                      var italic = /‘(.*?)’/g;
                                      return value.replace(bold, "<b>“$1”</b>").replace(italic, "<i>‘$1’</i>");
                                  }

                                  $scope.legals = result.data[userConfig.broker] || result.data.TF;

                                  $scope.legals.introParagraphs = $scope.legals.introParagraphs.map(htmlify);
                                  $scope.legals.sections.forEach(function (s) {
                                      s.content = htmlify(s.content);
                                  })
                              });

                         $scope.wizard = wizard;

                         $scope.openBrokerList = function () {
                             $scope.isBrokerListOpen = true;
                         };

                         $scope.closeBrokerList = function () {
                             $scope.isBrokerListOpen = false;
                         };

                         $scope.connectedBrokersSearch = "";

                         $scope.valueBrokers = [
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 0,
                                 col: 0,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "Ascot",
                                 src: "assets/img/logos/ascot.png"
                             },
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 2,
                                 col: 4,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "Ausiex",
                                 src: "assets/img/logos/Sequoia.png"
                             },
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 0,
                                 col: 2,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "CMC Markets",
                                 src: "assets/img/logos/cmc.png"
                             },
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 0,
                                 col: 4,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "CommSec",
                                 src: "assets/img/logos/commsec.png"
                             },
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 2,
                                 col: 0,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "Morgans",
                                 src: "assets/img/logos/morgans.png"
                             },
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 2,
                                 col: 2,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "Philip Capital",
                                 src: "assets/img/logos/PhillipCapitalAustralia.jpg"
                             },
                             {
                                 sizeX: 2,
                                 sizeY: 1,
                                 row: 2,
                                 col: 4,
                                 posFeed: "daily",
                                 cashFeed: "daily",
                                 title: "Sequoia",
                                 src: "assets/img/logos/Sequoia.png"
                             },
                         ];

                         $scope.onlineBrokers = [
                             {sizeX: 2, sizeY: 1, row: 1, col: 0, title: "ANZ Share Investing"},
                             {sizeX: 2, sizeY: 1, row: 1, col: 0, title: "Interactive Brokers"},
                             {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "OpenMarkets"},
                             {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "NAB"},
                             {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "Westpac Online"}
                         ];

                         $scope.connectedBrokers = [
                             {sizeX: 1, sizeY: 1, row: 0, col: 0, title: "Pulse"},
                             {sizeX: 1, sizeY: 1, row: 1, col: 0, title: "APP Securities"},
                             {sizeX: 1, sizeY: 1, row: 0, col: 1, title: "Phillip Capital"},
                             {sizeX: 1, sizeY: 1, row: 1, col: 1, title: "Morgans"},
                             {sizeX: 1, sizeY: 1, row: 0, col: 3, title: "d2mx"},
                             {sizeX: 1, sizeY: 1, row: 3, col: 3, title: "Ausiex"}
                         ];

                         $scope.otherBrokers = [
                             {title: "Ausiex"},
                             {title: "ABN AMRO Clearing"},
                             {title: "APP Securities"},
                             {title: "Argonaut Securities"},
                             {title: "Baillieu Holst"},
                             {title: "Baker Young"},
                             {title: "Bell Potter"},
                             {title: "Bell Direct"},
                             {title: "Burrell"},
                             {title: "CognitiveWealth"},
                             {title: "D2MX"},
                             {title: "Evans and Partners"},
                             {title: "Hartleys"},
                             {title: "Macquarie"},
                             {title: "Morgan Stanley WM"},
                             {title: "NAB"},
                             {title: "Ord Minnett"},
                             {title: "Paterson"},
                             {title: "Pulse Markets"},
                             {title: "Phillip Capital"},
                             {title: "Rivkin Securities"},
                             {title: "SelfWealth"},
                             {title: "Sentinel"},
                             {title: "Sequoia"},
                             {title: "Shadforths"},
                             {title: "Shaw and Partners"},
                             {title: "TradersCircle"},
                             {title: "UBS"},
                             {title: "Vested Securities"},
                             {title: "Wealthhub Securities"},
                             {title: "Wilson HTM"}

                         ];

                         $scope.setBroker = function (broker) {
                             wizard.setupData.brokerName = broker.title;
                             $scope.isBrokerListOpen = false;
                         };

                         $scope.manualBroker = {
                             title: null
                         };

                         $scope.setManualBroker = function () {
                             wizard.setupData.brokerName = $scope.manualBroker.title;
                             $scope.isBrokerListOpen = false;
                             $scope.manualBroker.title = null
                         };

                         $scope.gridsterOpts = {
                             columns: 6, // the width of the grid, in columns
                             pushing: true, // whether to push other items out of the way on move or resize
                             floating: true, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                             swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
                             width: "auto", // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                             colWidth: "auto", // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                             rowHeight: "172", // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                             margins: [10, 10], // the pixel distance between each widget
                             outerMargin: false, // whether margins apply to outer edges of the grid
                             isMobile: true, // stacks the grid items if true
                             mobileBreakPoint: 500, // if the screen is not wider that this, remove the grid layout and stack the items
                             mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                             minColumns: 1, // the minimum columns the grid must have
                             minRows: 1, // the minimum height of the grid, in rows
                             maxRows: 100,
                             defaultSizeX: 2, // the default width of a gridster item, if not specifed
                             defaultSizeY: 1, // the default height of a gridster item, if not specified
                             minSizeX: 1, // minimum column width of an item
                             maxSizeX: null, // maximum column width of an item
                             minSizeY: 1, // minumum row height of an item
                             maxSizeY: null, // maximum row height of an item
                             resizable: {
                                 enabled: false,
                                 handles: ["n", "e", "s", "w", "ne", "se", "sw", "nw"],
                                 start: function (event, $element, widget) {
                                 }, // optional callback fired when resize is started,
                                 resize: function (event, $element, widget) {
                                 }, // optional callback fired when item is resized,
                                 stop: function (event, $element, widget) {
                                 } // optional callback fired when item is finished resizing
                             },
                             draggable: {
                                 enabled: false, // whether dragging items is supported
                                 handle: ".my-class", // optional selector for resize handle
                                 start: function (event, $element, widget) {
                                 }, // optional callback fired when drag is started,
                                 drag: function (event, $element, widget) {
                                 }, // optional callback fired when item is moved,
                                 stop: function (event, $element, widget) {
                                 } // optional callback fired when item is finished dragging
                             }
                         };

                         $scope.gridsterOnlineOpts = {
                             columns: 5, // the width of the grid, in columns
                             pushing: true, // whether to push other items out of the way on move or resize
                             floating: true, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                             swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
                             width: "auto", // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                             colWidth: "auto", // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                             rowHeight: "110", // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                             margins: [10, 10], // the pixel distance between each widget
                             outerMargin: false, // whether margins apply to outer edges of the grid
                             isMobile: true, // stacks the grid items if true
                             mobileBreakPoint: 400, // if the screen is not wider that this, remove the grid layout and stack the items
                             mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                             minColumns: 1, // the minimum columns the grid must have
                             minRows: 1, // the minimum height of the grid, in rows
                             maxRows: 100,
                             defaultSizeX: 1, // the default width of a gridster item, if not specifed
                             defaultSizeY: 1, // the default height of a gridster item, if not specified
                             minSizeX: 1, // minimum column width of an item
                             maxSizeX: null, // maximum column width of an item
                             minSizeY: 1, // minumum row height of an item
                             maxSizeY: null, // maximum row height of an item
                             resizable: {
                                 enabled: false,
                                 handles: ["n", "e", "s", "w", "ne", "se", "sw", "nw"],
                                 start: function (event, $element, widget) {
                                 }, // optional callback fired when resize is started,
                                 resize: function (event, $element, widget) {
                                 }, // optional callback fired when item is resized,
                                 stop: function (event, $element, widget) {
                                 } // optional callback fired when item is finished resizing
                             },
                             draggable: {
                                 enabled: false, // whether dragging items is supported
                                 handle: ".my-class", // optional selector for resize handle
                                 start: function (event, $element, widget) {
                                 }, // optional callback fired when drag is started,
                                 drag: function (event, $element, widget) {
                                 }, // optional callback fired when item is moved,
                                 stop: function (event, $element, widget) {
                                 } // optional callback fired when item is finished dragging
                             }
                         };

                         $scope.checkModel = {
                             fx: false,
                             futures: false,
                             gold: false,
                             bonds: false,
                             ozEquity: false,
                             intEquity: false,
                             news: false,
                             techAnalysis: false,
                             fundAnalysis: false,
                             expertComments: false,
                             etf: false,
                             smsf: false
                         };

                         $scope.decline = function () {
                             return $http.get("/tradefloor/api/logout").then(function (response) {
                                 $window.location.href = response.headers("location") || "/";
                             });
                         };

                         $scope.goBack = function () {
                             wizard.goToPrevious();
                         };

                         $scope.passTwo = function () {
                             wizard.pagePass.step2 = true;
                             wizard.goToNext();
                         };

                         // TODO move this into a constant
                         $scope.interests = [
                             {
                                 name: "FX",
                                 description: "FOREX"
                             },
                             {
                                 name: "FUTURES",
                                 description: "Futures"
                             },
                             {
                                 name: "GOLD",
                                 description: "Gold"
                             },
                             {
                                 name: "BONDS",
                                 description: "Bonds"
                             },
                             {
                                 name: "AUS_EQUITIES",
                                 description: "Australian Equities"
                             },
                             {
                                 name: "INTL_EQUITIES",
                                 description: "International Equities"
                             },
                             {
                                 name: "NEWS",
                                 description: "News"
                             },
                             {
                                 name: "TECH_ANALYSIS",
                                 description: "Technical Analysis"
                             },
                             {
                                 name: "FUND_ANALYSIS",
                                 description: "Fundamental Analysis"
                             },
                             {
                                 name: "EXPERT_COMMENTS",
                                 description: "Expert Comments"
                             },
                             {
                                 name: "ETF",
                                 description: "ETFs"
                             },
                             {
                                 name: "SMSF",
                                 description: "SMSF"
                             }
                         ];

                         $scope.passFour = function () {
                             var interests = $scope.interests.filter(function (i) {
                                 return i.selected;
                             });
                             if (interests.length < 3) {
                                 wizard.pagePass.step4 = null;
                             } else {
                                 wizard.pagePass.step4 = true;
                             }
                         };

                         $scope.goNext = function () {
                             wizard.goToNext();
                         };

                         function buildDemographics() {
                             wizard.setupData.interests = [];

                             var interests = $scope.interests.filter(function (i) {
                                 return i.selected;
                             }).map(function (i) {
                                 return i.name;
                             });

                             return {
                                 country: wizard.setupData.country,
                                 state: wizard.setupData.state,
                                 postCode: wizard.setupData.postcode,
                                 gender: wizard.setupData.gender,
                                 ageGroup: wizard.setupData.age,
                                 yearOfBirth: null,
                                 equityExperience: wizard.setupData.experienceShares,
                                 derivativesExperience: wizard.setupData.experienceOptions,
                                 interests: interests,
                                 brokers: wizard.setupData.brokerName,
                                 sophisticatedOrWholesale: wizard.setupData.sophisticatedOrWholesale
                             };
                         }

                         async function submitUserData(demographics) {
                             const terms = $http.put("/tradefloor/api/user/legal/terms");
                             const demo = $http.post("/tradefloor/api/user/demographics", demographics);
                             const onboard = $http.put("/tradefloor/api/user/onboard");

                             let postArray = [];
                             postArray.push(terms, demo, onboard);

                             if (wizard.setupData.userName != null) {
                                 const alias = $http.post("/tradefloor/api/user/alias", wizard.setupData.userName);
                                 postArray.push(alias);
                             }

                             if (wizard.setupData.phone != null && wizard.setupData.phone !== "") {
                                 const phone = $http.post("/tradefloor/api/user/" + userConfig.id + "/phone", wizard.setupData.phone);
                                 postArray.push(phone);
                             }

                             await Promise.all(postArray);
                         }

                         $scope.submit = async function () {
                             try {
                                 const demographics = buildDemographics();
                                 await submitUserData(demographics);
                             } finally {
                                 wizard.submit();
                             }
                         };

                         $scope.cardCreated = (card) => {
                             // TODO Implement this bit
                             // await $http.subscribeToPackage
                             $scope.submit();
                         };

                         $scope.accept = function () {
                             wizard.setupData.legal = true;
                             $timeout(function () {
                                 wizard.goToNext();
                             });
                         };

                         //    DROPZONE CODE

                         $scope.dropzoneConfig = {
                             "options": { // passed into the Dropzone constructor
                                 "url": "/tradefloor/api/upload/" + "0" + "/portfolio"
                             },
                             "eventHandlers": {
                                 "sending": function (file, formData, xhr) {
                                 },
                                 "success": function (file, response) {
                                     $scope.showEdit = true;
                                     $scope.showUpload = false;
                                     if (response.length) {
                                         for (var i = 0; i < response.length; i++) {
                                             var position = response[i];

                                             var exists = false;
                                             for (var j = 0; j < wizard.setupData.startingPositions.length; j++) {
                                                 var startPosition = wizard.setupData.startingPositions[j];
                                                 if (startPosition.code == position.c && startPosition.p == position.p) {
                                                     startPosition.quantity += position.q;
                                                     exists = true;
                                                 }
                                             }

                                             if (!exists) {
                                                 var newStartPosition = {
                                                     code: position.c,
                                                     quantity: position.q,
                                                     price: position.p,
                                                     tradeDate: position.t

                                                 };
                                                 wizard.setupData.startingPositions.push(newStartPosition);
                                             }
                                         }
                                     }
                                     $scope.$digest();
                                 }
                                 ,
                                 "dragstart": function () {
                                     $scope.showUploader();
                                 }
                             }
                         };


                     }])
                     .controller("welcomeCtrl", ["$scope", "$uibModal", "userConfig", "$state", function ($scope, $uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({

                             templateUrl: "app/layout/wizard/welcome-wizard/welcome.tpl.html",
                             backdrop: "static",
                             keyboard: false,
                             //windowClass: 'margin-top25',
                             controller: "legalCtrl",
                             windowTopClass: "overZendesk",
                             size: "fs",
                             resolve: {}
                         });
                         modalInstance.result.then(function (result) {
                             if (userConfig.broker == "TC") {
                                 if (userConfig.favourites.length == 1) {
                                     $state.go("portfolio", {portfolioId: userConfig.favourites[0].id});
                                 } else {
                                     $state.go("home");
                                 }
                             } else {
                                 $state.go("home");
                             }

                         });
                     }])
                     .controller("tcWelcomeCtrl", ["$scope", "$uibModal", "userConfig", "$state", function ($scope, $uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({

                             templateUrl: "app/layout/tcWizard/welcomeWizard.tpl.html",
                             backdrop: "static",
                             keyboard: false,
                             //windowClass: 'margin-top25',
                             controller: "legalCtrl",
                             windowTopClass: "overZendesk",
                             size: "fs",
                             resolve: {}
                         });
                         modalInstance.result.then(function (result) {
                             if (userConfig.broker == "TC") {
                                 if (userConfig.favourites.length == 1) {
                                     $state.go("portfolio", {portfolioId: userConfig.favourites[0].id});
                                 } else {
                                     $state.go("home");
                                 }
                             } else {
                                 $state.go("home");
                             }
                         });
                     }])
                     .controller("toWelcomeCtrl", ["$scope", "$uibModal", "userConfig", "$state", function ($scope, $uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({

                             templateUrl: "app/layout/wizard/toWizard/welcomeWizard.tpl.html",
                             backdrop: "static",
                             keyboard: false,
                             //windowClass: 'margin-top25',
                             controller: "legalCtrl",
                             size: "fs",
                             windowTopClass: "overZendesk",
                             resolve: {}
                         });
                         modalInstance.result.then(function (result) {
                             $state.go("home");
                         });

                     }])

                     .controller("autoJoinLeagueCtrl", ["$scope", "$uibModal", "userConfig", "$state", "$stateParams", "leaderBoardService", function ($scope, $uibModal, userConfig, $state, $stateParams, leaderBoardService) {
                         var leagueName = $stateParams.name;
                         var code = $stateParams.code;

                         leaderBoardService.joinLeague(leagueName, code).finally(function () {
                             $state.go("home");
                         });
                     }])
                     .controller("gameWelcomeCtrl", ["$scope", "$uibModal", "userConfig", "$state", function ($scope, $uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({

                             templateUrl: "app/layout/wizard/game/welcomeWizard.tpl.html",
                             backdrop: "static",
                             keyboard: false,
                             //windowClass: 'margin-top25',
                             controller: GameWelcomeWizardController,
                             controllerAs: "ctrl",
                             windowTopClass: "overZendesk",
                             size: "fs",
                             resolve: {}
                         });
                         modalInstance.result.then(function (result) {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("ivWelcomeCtrl", ["$scope", "$uibModal", "userConfig", "$state", function ($scope, $uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({

                             templateUrl: "app/layout/wizard/ivWizard/welcomeWizard.tpl.html",
                             backdrop: "static",
                             keyboard: false,
                             //windowClass: 'margin-top25',
                             controller: IvWelcomeWizardController,
                             controllerAs: "ctrl",
                             windowTopClass: "overZendesk",
                             size: "fs",
                             resolve: {}
                         });
                         modalInstance.result.then(function (result) {
                             $state.go("home");
                         });
                     }])
                        .controller("iinvestWelcomeCtrl", ["$scope", "$uibModal", "userConfig", "$state", function ($scope, $uibModal, userConfig, $state) {
                            var modalInstance = $uibModal.open({

                                templateUrl: "app/layout/wizard/iinvest/welcomeWizard.tpl.html",
                                backdrop: "static",
                                keyboard: false,
                                //windowClass: 'margin-top25',
                                controller: IInvestWelcomeWizardController,
                                controllerAs: "ctrl",
                                windowTopClass: "overZendesk",
                                size: "fs",
                                resolve: {}
                            });
                            modalInstance.result.then(function (result) {
                                $state.go("home");
                            });
                        }])

                     .controller("openTraderWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: OpenTraderWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("omWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: OpenMarketsWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("bellmontWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: BellmontWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("futureAssistWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: FutureAssistWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("allfinWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: AllfinWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("waimakWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: WaimakWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("suubeeWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: SuubeeWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("liquidityWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: LiquidityWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("fxeWelcomeCtrl", ["$uibModal", "userConfig", "$state", function ($uibModal, userConfig, $state) {
                         var modalInstance = $uibModal.open({
                             component: FxeWelcomeWizard,
                             backdrop: "static",
                             keyboard: false,
                             windowTopClass: "overZendesk",
                             size: "fs"
                         });
                         modalInstance.result.then(() => {
                             userConfig.client.onBoarded = new Date();
                             $state.go("home");
                         });
                     }])

                     .controller("bodyCtrl", ["$rootScope", "$scope", "photoUpload", "$uibModal", "gameLoss", "userConfig", "growl", "navSvc", "upgradeBrowser", "$localStorage", "$state", "breakpointObserver", "asxGameService", "ivSidebarService", "currentUserService", "navigationModelService", "clientEventService",
                         function ($rootScope, $scope, photoUpload, $uibModal, gameLoss, userConfig, growl, navSvc, upgradeBrowser, $localStorage, $state, breakpointObserver, asxGameService, ivSidebarService, currentUserService, navigationModelService, clientEventService) {

                             $scope.currentYear = new Date().getFullYear();

                             ivSidebarService.onStateChange().subscribe(isOpen => {
                                 $scope.sidebarOpen = isOpen;
                             });

                             // TODO We should manage this from the sidebar component/store
                             const sidebarTabFeatures = [FeatureNames.SIDEBAR_NEWS, FeatureNames.SIDEBAR_WATCHLIST, FeatureNames.TRADING_ALERTS];
                             $rootScope.ivStyleView = currentUserService.hasFeature(...sidebarTabFeatures);

                             $rootScope.view = "desktop";

                             if (!$rootScope.ivStyleView) {
                                 ivSidebarService.stateChanged(false);
                             }

                             breakpointObserver.map(change => change.current)
                                               .subscribe(current => {
                                                   switch (current) {
                                                       case Breakpoint.XL:
                                                       case Breakpoint.LG:
                                                           $rootScope.view = "desktop";
                                                           break;
                                                       case Breakpoint.MD:
                                                           $rootScope.view = "tablet";
                                                           ivSidebarService.stateChanged(false);
                                                           break;
                                                       case Breakpoint.SM:
                                                       case Breakpoint.XS:
                                                           $rootScope.view = "mobile";
                                                           ivSidebarService.stateChanged(false);
                                                           break;
                                                       default:
                                                           throw Error(`Unknown Breakpoint of ${current}`)
                                                   }
                                                   $rootScope.$applyAsync()
                                               });

                             $rootScope.iressActivated = false;

                             if (userConfig.branding === "GAME" ||
                                 userConfig.branding === "NEWCASTLE") {
                                 asxGameService.dates().then(dates => {
                                     $rootScope.gamePreOpen = dates.isPreOpen;
                                     $rootScope.gameOver = dates.isFinished;
                                 });
                             }

                             $scope.confirmationPopup = function () {
                                 gameLoss.open();
                             };

                             $scope.navSvc = navSvc;

                             $scope.isMobileNav = false;
                             $scope.hasSidebar = false;
                             $scope.sidebarPinned = false;

                             navigationModelService.isMobileNav
                                                   .subscribe((isMobile) => {
                                                       $scope.$applyAsync(() => {
                                                           $scope.isMobileNav = isMobile;
                                                       });
                                                   });

                             navigationModelService.sidebarVisible
                                                   .subscribe((hasSidebar) => {
                                                       $scope.$applyAsync(() => {
                                                           $scope.hasSidebar = hasSidebar;
                                                       })
                                                   });

                             navigationModelService.sidebarPinned
                                                   .subscribe((pinned) => {
                                                       $scope.$applyAsync(() => $scope.sidebarPinned = pinned);
                                                   });

                             if (userConfig.browser.indexOf("Internet Explorer") > -1 && (userConfig.browser.indexOf("10") > -1 || userConfig.browser.indexOf("9") > -1) && !$localStorage.acceptBrowserSuggest && userConfig.backOffice != "SHAW") {
                                 var attrs = {
                                     reason: "oldIE"
                                 };
                                 upgradeBrowser.open(attrs);
                             } else if (userConfig.browser.indexOf("Chrome") == -1 && userConfig.browser.indexOf("Firefox") == -1 && userConfig.browser.indexOf("Safari") == -1 && !$localStorage.acceptBrowserSuggest && userConfig.backOffice != "SHAW") {
                                 var attrs = {
                                     reason: "notChrome"
                                 };
                                 upgradeBrowser.open(attrs);
                             }

                             clientEventService.events()
                                               .filter((evt) => evt.type === ClientEventType.SESSION_UPDATED)
                                               .subscribe(() => currentUserService.refreshConfig())
                         }]);
}